import { createSelector } from 'reselect';

import { CalendarParty } from 'types';
import { concat } from 'es-toolkit/compat';
import bookedCalendarItemsSelector from 'selectors/bookedCalendarItemsSelector';
import walkInCalendarItemSelector from 'selectors/walkInCalendarItemSelector';

/**
 * Selector for parties to display in calendar that come from walk-ins.
 */
export default createSelector(
  bookedCalendarItemsSelector,
  walkInCalendarItemSelector,
  (bookedParties: CalendarParty[], walkInParties: CalendarParty[]): CalendarParty[] => {
    return concat(bookedParties, walkInParties);
  }
);
